import { jsx as _jsx } from "react/jsx-runtime";
import Notification from '@/components/molecules/Notification';
import { useState } from 'react';
export function useNotifications() {
    const [notifications, setNotifications] = useState([]);
    const push = (theme, contents) => {
        const id = Math.random().toString(36);
        setNotifications((notifications) => [...notifications, { id, theme, contents }]);
    };
    const components = notifications.length ? (_jsx("div", { className: "fixed left-0 right-0 top-0 z-notification", children: notifications.map(({ id, theme, contents }) => (_jsx(Notification, { theme: theme, onClose: () => setNotifications((notifications) => notifications.filter((notification) => notification.id !== id)), children: contents }, id))) })) : null;
    return { push, components };
}
